import React, {useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import useAuth from "../auth/useAuth";
import routes from '../routers/helpers/routes'
import { isAndroid, isMobile, isIOS } from 'react-device-detect';

export default function Aside(props) {
  const {user} = useAuth();
  const {name, organization, numFreeCredits} = user;
  const freeCredits = numFreeCredits > 0 ? true : false
  const [showMessage, setShowMessage] = useState(false);
  const [showContacts, setShowContacts] = useState(false);
  const [showLinks, setShowLinks] = useState(false);
  const [showAdmin, setShowAdmin] = useState(false);
  const [viewToggle, setViewToggle] = useState(props.toggleSidebar)
 

  const toggle = viewToggle ? 215 : 10;
  const stateCollapse = viewToggle ? 'collapse-horizontal collapse show' : 'collapse-horizontal collapse'
  const arrow = viewToggle ? "fa fa-angle-double-left" : "fa fa-angle-double-right"

  const [classActiveMessage, setClassActiveMessage] = useState('');
  const [classActiveContacts, setClassActiveContacts] = useState('');
  const [classActiveLinks, setClassActiveLinks] = useState('');
  const [classActiveAdmin, setClassActiveAdmin] = useState('');

  const asideToggleRef = useRef();

  const clickToogle = () => {
    if(isAndroid || isMobile || isIOS) {
      asideToggleRef.current.click();
    }
  }

  const handleAsideToggle = () => {
    props.handleToggle();
    setViewToggle(!viewToggle);
  }

  const closeSession = async() => {
    window.localStorage.clear();
    await props.logout();
  }

  return (
    <div style={{display:"grid", maxWidth: `${toggle + 88 }px`, transition: 'all 0.5s'}}>

      <a ref={asideToggleRef} onClick={handleAsideToggle} className="nav-link toggle-sidebar" style={{
        marginLeft:`${toggle}px`}} data-bs-toggle="collapse" href="#collapse-sidebar" role="button" aria-expanded="false" aria-controls="collapse-sidebar">
              <i id='ArrowSidebar' className= {`${arrow}`} style= {{transition: 'all 0.5s'}}/>Menú
      </a>
      {/* <NavLink to={'/'} >Home</NavLink> */}

      <nav className= {stateCollapse} id="collapse-sidebar" style={{position: 'fixed'}}>

        <div
          className="d-flex flex-column vh-100 flex-shrink-0 p-3 text-white bg-dark"
          style={{ maxHeight: 640 }}
        >

          <div>
            <NavLink onClick={clickToogle} className={'organization'} to={routes.dashboard + '/' + routes.dashboardUser} style={{textDecorationLine:'none', color: 'whitesmoke'}} >
            < span className="fs-6">{organization}</span>
            </NavLink>
          </div>
         
          <hr />
          <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          {user.admin && <li className="nav-item menu-open" onClick={() => {
              setShowAdmin(true);
              setShowMessage(false);
              setShowContacts(false);
              setShowLinks(false)
              setClassActiveAdmin('active')
              setClassActiveMessage('');
              setClassActiveContacts('');
              setClassActiveLinks('');
            }}>
              <a className = {`nav-link aside text-white item-home ${classActiveAdmin}`} aria-current="page"  data-bs-toggle="collapse" href="#collapse-admin" role="button" aria-expanded="false" aria-controls="collapse-admin">
                <i className="fa fa-sms item-home" />
                <span className="ms-2 item-home">Menú Admin</span>
              </a>
              <div className= {showAdmin? 'collapse show' : 'collapse'} id="collapse-admin" style={{transition: 'all 0.5s'}}>
                <ul className="nav nav-treeview" style={{display:'grid'}}>

                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={'/dashboard/user/approvemessage'} className="nav-link">
                      <i class="fas fa-thumbs-up" />
                        <span className="ms-2">Aprobar Mensajes</span>
                      </NavLink>
                    </li>
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={'/dashboard/user/addcredits'} className="nav-link">
                      <i class="fas fa-coins"/>
                        <span className="ms-2">Adicionar Créditos</span>
                      </NavLink>
                    </li>
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={'/dashboard/user/list-auth-messages'} className="nav-link">
                      <i class="fas fa-check"></i>
                        <span className="ms-2">Aprobados</span>
                      </NavLink>
                    </li>
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to= {routes.dashboard + '/'+ routes.historial} className="nav-link">
                        <i className="fa fa-book" />
                        <span className="ms-2">Historial</span>
                      </NavLink>
                    </li>
                </ul>
              </div>
            </li>}

            <li className="nav-item menu-open" onClick={() => {
              setShowMessage(true);
              setShowContacts(false);
              setShowLinks(false)
              setShowAdmin(false);
              setClassActiveAdmin('');
              setClassActiveMessage('active');
              setClassActiveContacts('');
              setClassActiveLinks('');
            }}>
              <a className = {`nav-link aside text-white item-home ${classActiveMessage}`} aria-current="page"  data-bs-toggle="collapse" href="#collapse-message" role="button" aria-expanded="false" aria-controls="collapse-message">
                <i className="fa fa-sms item-home" />
                <span className="ms-2 item-home">Mensajes</span>
              </a>
              <div className= {showMessage? 'collapse show' : 'collapse'} id="collapse-message" style={{transition: 'all 0.5s'}}>
                <ul className="nav nav-treeview" style={{display:'grid'}}>

                    {freeCredits && <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={'/dashboard/user/freemessages'} className="nav-link">
                        <i className="fa fa-gift" />
                        <span className="ms-2">Mensages Gratis</span>
                      </NavLink>
                    </li>}

                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={'/dashboard/user/newmessage'} className="nav-link">
                        <i className="fa fa-paper-plane" />
                        <span className="ms-2">Predeterminados</span>
                      </NavLink>
                    </li>
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={'/dashboard/user/pendingmessages'} className="nav-link">
                      <i class="far fa-clock"/>
                        <span className="ms-2">Pendientes</span>
                      </NavLink>
                    </li>
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={'/dashboard/user/mymessages'} className="nav-link">
                        <i class="fas fa-smile"/>
                        <span className="ms-2">Aprobados</span>
                      </NavLink>
                    </li>
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to= {routes.dashboard + '/'+ routes.historial} className="nav-link">
                        <i className="fa fa-book" />
                        <span className="ms-2">Historial</span>
                      </NavLink>
                    </li>
                </ul>
              </div>
            </li>

            <li className="nav-item  menu-open" onClick={() => {
              setShowContacts(true);
              setShowMessage(false);
              setShowLinks(false);
              setShowAdmin(false);
              setClassActiveAdmin('');
              setClassActiveMessage('');
              setClassActiveContacts('active');
              setClassActiveLinks('');
            }}>
              <a className={`nav-link text-white aside item-home ${classActiveContacts}`} aria-current="page"  data-bs-toggle="collapse" href="#collapse-contacts" role="button" aria-expanded="false" aria-controls="collapse-contacts">
                <i className="fa fa-address-book" />
                <span className="ms-2">Contactos</span>
              </a>

              <div className= {showContacts? 'collapse show' : 'collapse'} id="collapse-contacts" style={{transition: 'all 0.5s'}}>
                <ul className="nav nav-treeview" style={{display:'grid'}}>
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={routes.dashboard + '/' + routes.newContact} className="nav-link">
                        <i className="fa fa-user-plus" />
                        <span className="ms-2">Nuevo Contacto</span>
                      </NavLink>
                    </li>
                    
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={routes.dashboard + '/' + routes.groups} className="nav-link">
                        <i className="fa fa-users" />
                        <span className="ms-2">Grupos</span>
                      </NavLink>
                    </li>
                </ul>
              </div>

            </li>

            <li className="nav-item  menu-open" onClick={() => {
              setShowLinks(true);
              setShowMessage(false);
              setShowContacts(false);
              setShowAdmin(false);
              setClassActiveAdmin('');
              setClassActiveMessage('');
              setClassActiveContacts('');
              setClassActiveLinks('active');
            }}>
              <a className={`nav-link text-white aside item-home ${classActiveLinks}`} aria-current="page"  data-bs-toggle="collapse" href="#collapse-links" role="button" aria-expanded="false" aria-controls="collapse-links">
                <i className="fa fa-link" />
                <span className="ms-2">Links</span>
              </a>

              <div className= {showLinks? 'collapse show' : 'collapse'} id="collapse-links" style={{transition: 'all 0.5s'}}>
                <ul className="nav nav-treeview" style={{display:'grid'}}>
                    <li className="nav-item ms-2">
                      <NavLink onClick={clickToogle} to={routes.dashboard + '/' + routes.newLink} className="nav-link">
                        <i className="fa fa-external-link-square-alt" />
                        <span className="ms-2">Nuevo Link</span>
                      </NavLink>
                    </li>
                   
                </ul>
              </div>

            </li>

          </ul>
          <hr />
          <div className="dropdown">

            <a
              href="#"
              className="d-flex align-items-center text-white text-decoration-none dropdown-toggle"
              id="dropdownUser1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >

              <img
                src="/user.png"
                alt =""
                width={32}
                height={32}
                className="rounded-circle me-2"
              />
              <strong> {name} </strong>
            </a>
            <ul
              className="dropdown-menu dropdown-menu-dark text-small shadow"
              aria-labelledby="dropdownUser1"
            >
             
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <a className="dropdown-item" href="/dashboard/user" onClick={closeSession}>
                  Sign out
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

    </div>

  );
}
